<template>
  <nav :aria-label="ariaLabel">
    <SbSelect
      :data-testid="`${inputId}-select`"
      :options="options"
      :model-value="modelValue"
      :hidden-label="hiddenLabel"
      inline
      disable-filter
      infinite-scroll
      :labeled-by="labeledBy"
      :navigational-select="navigationalSelect"
      @update:model-value="onChange"
      @load-more="emit('load-more')"
    />
  </nav>
</template>

<script lang="ts" setup>
import SbSelect from '../../Select'

export type PaginationSelect = {
  options: Array<{ label: string; value: number; ariaLabel: string }>
  modelValue: number
  inputId?: string
  navigationalSelect?: boolean
  labeledBy?: string
  hiddenLabel?: string
  ariaLabel?: string
}

const props = withDefaults(defineProps<PaginationSelect>(), {
  modelValue: 1,
  inputId: '',
  navigationalSelect: false,
  ariaLabel: 'Pagination Select',
})

const emit = defineEmits<{
  (e: 'change', value: number): void
  (e: 'load-more'): void
}>()

function onChange(value: number) {
  emit('change', value)
}
</script>
